import SwiperCore, { Pagination, Navigation } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import Image from 'next/image'
import styles from './index.module.scss'
import useBreakpoint from 'hooks/useBreakPoint'

SwiperCore.use([Pagination, Navigation])

const ReviewPanel: React.FC<ReviewPanelProps> = ({ reviewsData }) => {
  const { isMobileScreen } = useBreakpoint()

  return (
    <div className={styles.review_panel}>
      <Swiper
        key={isMobileScreen ? 'mobileReviewPanel' : 'desktopReviewPanel'}
        slidesPerView={isMobileScreen ? 1 : 3}
        allowSlideNext={isMobileScreen}
        allowSlidePrev={isMobileScreen}
        allowTouchMove={isMobileScreen}
        pagination={{
          clickable: false,
          bulletClass: 'review-panel-carousel-custom-pagination-bullet',
        }}
        observer
        className="review-panel-carousel-wrapper"
      >
        {reviewsData.map((review) => (
          <SwiperSlide key={review.id}>
            <div className={styles.review_panel__container}>
              <div className={styles.review_panel__content}>
                <div className={styles.review_panel__reviewImage}>
                  <Image
                    src="/images/review-panel-star.svg"
                    width={152}
                    height={24}
                    alt="Review stars"
                    priority
                  />
                </div>
                <div className={styles.review_panel__reviewInfo}>
                  {review.reviewText}
                </div>
                <div className={styles.review_panel__authorInfo}>
                  <p>{review.dateInfo}</p>
                  <p className={styles.review_panel__reviewFrom}>
                    Review left on Thriveworks.com
                  </p>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}

export default ReviewPanel
